import { render, staticRenderFns } from "./SurveyFriendResponses.vue?vue&type=template&id=2d3c9b1e&"
import script from "./SurveyFriendResponses.vue?vue&type=script&lang=js&"
export * from "./SurveyFriendResponses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports